// Pages d'atterrissage SEO — une page par grande requête de recherche.
// Contenu éditorial unique par page (éviter le contenu dupliqué, pénalisé par Google).

export const SEO_PAGES = [
  {
    slug: "liquidation-judiciaire-paris",
    tag: "Procédure collective · Paris",
    h1: "Liquidation judiciaire à Paris : fermer sans tout perdre.",
    lede:
      "Quand l'entreprise ne peut plus être sauvée, la liquidation judiciaire permet d'arrêter proprement : dettes traitées dans un cadre légal, dirigeant protégé, avenir préparé. Vous choisissez d'engager la procédure ; ProSecours prépare les actes, réunit les pièces et organise le dépôt auprès du greffe compétent.",
    sections: [
      {
        h: "Quand la liquidation devient inévitable",
        p: [
          "La liquidation judiciaire est prononcée lorsque l'entreprise est en cessation de paiement et que son rétablissement est manifestement impossible. Ce n'est pas un échec honteux : c'est un cadre légal pensé pour clore une situation devenue intenable.",
          "Le pire scénario n'est pas la liquidation — c'est le retard. Chaque semaine d'attente aggrave le passif, fragilise le dirigeant personnellement et réduit les options. Un dépôt de bilan préparé à temps protège au contraire votre responsabilité et votre capacité à rebondir.",
        ],
      },
      {
        h: "Le déroulé devant le tribunal de commerce",
        p: [
          "Tout commence par la déclaration de cessation de paiement (le « dépôt de bilan ») auprès du greffe du tribunal de commerce du siège social, dans les 45 jours de la cessation de paiement. Le tribunal convoque ensuite le dirigeant, examine le dossier économique et prononce — ou non — la liquidation.",
          "Un liquidateur judiciaire est nommé : il vend les actifs, paie les créanciers dans l'ordre légal et clôt les opérations. Pendant ce temps, le dirigeant doit rester disponible et coopératif — c'est aussi ce que le tribunal retient.",
        ],
      },
      {
        h: "Protéger le dirigeant pendant la procédure",
        p: [
          "La crainte numéro un des dirigeants est personnelle : insuffisance d'actif, interdiction de gérer, cautionnements appelés. Ces risques ne se matérialisent presque jamais quand le dossier est propre, les délais respectés et la gestion documentée.",
          "Notre rôle : construire un dossier complet, dater précisément la cessation de paiement, réunir les pièces attendues et organiser la prise de date puis le dépôt auprès du greffe compétent.",
        ],
      },
    ],
    faqs: [
      {
        q: "Quelle différence entre dépôt de bilan et liquidation judiciaire ?",
        a: "Le dépôt de bilan est la déclaration de cessation de paiement faite par le dirigeant au greffe. La liquidation judiciaire est le jugement prononcé ensuite par le tribunal lorsque le redressement est impossible. Le premier est une démarche, la seconde une décision de justice.",
      },
      {
        q: "Suis-je personnellement responsable des dettes de ma société ?",
        a: "En principe non : la société répond de ses dettes sur son propre patrimoine. Votre responsabilité personnelle ne peut être engagée qu'en cas de faute de gestion (insuffisance d'actif), de garanties personnelles données aux banques, ou d'abus de biens sociaux. Une préparation rigoureuse des pièces réduit ces risques au minimum.",
      },
      {
        q: "Combien de temps dure une liquidation judiciaire ?",
        a: "De quelques mois à plus d'un an selon la taille du dossier, les actifs à vendre et les contentieux en cours. Les opérations simplifiées (petites entreprises sans actif) peuvent être clôturées rapidement.",
      },
    ],
    seo: {
      title: "Liquidation judiciaire Paris — préparation du dépôt | ProSecours",
      description:
        "Liquidation judiciaire à Paris : dépôt de bilan dans les 45 jours, rédaction des actes, pièces justificatives, prise de date et dépôt auprès du greffe compétent.",
      keywords:
        "liquidation judiciaire paris, liquidation judiciaire, liquidation juridique, fermer sa société, tribunal de commerce paris, liquidateur judiciaire",
    },
  },
  {
    slug: "depot-de-bilan",
    tag: "Cessation de paiement",
    h1: "Dépôt de bilan : les 45 jours qui décident de tout.",
    lede:
      "Votre entreprise ne peut plus payer ses dettes exigibles avec ses disponibilités ? Vous disposez de 45 jours pour déclarer la cessation de paiement. Bien utilisé, ce délai protège le dirigeant. Mal géré, il l'expose. ProSecours prépare votre dépôt de bilan en 72 heures.",
    sections: [
      {
        h: "Reconnaître la cessation de paiement",
        p: [
          "La cessation de paiement est définie par l'article L631-1 du Code de commerce : l'impossibilité de faire face au passif exigible avec l'actif disponible. Ce n'est pas une faillite morale, c'est un état de trésorerie — souvent réversible s'il est traité tôt.",
          "Beaucoup de dirigeants la datent trop tard, par espoir ou par crainte. Or c'est la date exacte qui détermine vos droits : conciliation possible, fenêtre des 45 jours, responsabilité protégée.",
        ],
      },
      {
        h: "Le dépôt au greffe, étape par étape",
        p: [
          "La déclaration se fait au greffe du tribunal de commerce du siège social (formulaire dédié), accompagnée d'un dossier économique : état actif-passif, comptes récents, prévisionnel de trésorerie, liste des créanciers, extrait Kbis.",
          "Le tribunal convoque ensuite le dirigeant en chambre du conseil et décide de la suite : redressement judiciaire si un rétablissement est possible, liquidation judiciaire sinon.",
        ],
      },
      {
        h: "Ce qu'un dossier bien préparé change",
        p: [
          "Un dépôt de bilan improvisé — comptes approximatifs, dates contradictoires, passif sous-estimé — détruit la crédibilité du dirigeant devant le tribunal et peut ouvrir la voie à une action en responsabilité.",
          "À l'inverse, un dossier daté, documenté et cohérent transforme l'audience : le tribunal voit un dirigeant de bonne foi qui a tout tenté. C'est exactement ce que nous construisons avec vous, en lien avec votre avocat.",
        ],
      },
    ],
    faqs: [
      {
        q: "Quel est le délai légal pour déposer le bilan ?",
        a: "45 jours à compter de la cessation de paiement. Au-delà, le dirigeant s'expose à une action en responsabilité pour insuffisance d'actif, voire à une interdiction de gérer. Si vous demandez l'ouverture d'une conciliation dans ce même délai, l'obligation de dépôt est suspendue.",
      },
      {
        q: "Dépôt de bilan ou conciliation : que choisir ?",
        a: "Si la cessation de paiement remonte à moins de 45 jours, la conciliation reste possible : elle est confidentielle, non publiée, et permet de négocier un étalement des dettes sans procédure collective. C'est souvent la meilleure option — d'où l'importance d'agir vite.",
      },
      {
        q: "Où déposer le bilan ?",
        a: "Au greffe du tribunal de commerce du siège social de l'entreprise (ou tribunal judiciaire pour les professions libérales et micro-entrepreneurs). Le dépôt peut se faire physiquement ou par voie électronique selon les greffes.",
      },
    ],
    seo: {
      title: "Dépôt de bilan — délai de 45 jours, procédure et conséquences | ProSecours",
      description:
        "Dépôt de bilan : déclaration de cessation de paiement dans les 45 jours, documents à fournir, rédaction des actes, prise de date et dépôt auprès du greffe compétent.",
      keywords:
        "dépôt de bilan, depot de bilan, déclarer cessation de paiement, cessation de paiement 45 jours, greffe tribunal de commerce",
    },
  },
  {
    slug: "redressement-judiciaire",
    tag: "Procédure collective",
    h1: "Redressement judiciaire : gagner du temps pour sauver l'entreprise.",
    lede:
      "Votre entreprise est en cessation de paiement mais son rétablissement reste possible ? Vous choisissez d'engager le redressement judiciaire ; ProSecours prépare la requête, réunit les pièces et organise la prise de date puis le dépôt auprès du greffe compétent.",
    sections: [
      {
        h: "La période d'observation : un bouclier temporaire",
        p: [
          "Dès le jugement d'ouverture, les créanciers ne peuvent plus vous poursuivre individuellement : les dettes antérieures sont gelées, les saisies suspendues. L'entreprise respire enfin — c'est le moment de reconstruire.",
          "Cette période dure 6 mois, renouvelable une fois. Elle est encadrée par un mandataire judiciaire (côté créanciers) et, selon la taille du dossier, un administrateur judiciaire (côté entreprise).",
        ],
      },
      {
        h: "Construire un plan de continuation crédible",
        p: [
          "Le plan de redressement est le cœur du dossier : périmètre conservé, emplois maintenus, échéancier de remboursement des créanciers sur 10 ans maximum, sources de financement.",
          "Un plan n'est convaincant que s'il repose sur des chiffres tenables : prévisionnel de trésorerie hebdomadaire, carnet de commandes documenté, hypothèses prudentes. C'est précisément notre métier.",
        ],
      },
      {
        h: "Votre référent unique pendant toute la procédure",
        p: [
          "Entre l'administrateur, le mandataire, le juge-commissaire, la banque et l'URSSAF, le dossier comporte de nombreux interlocuteurs. Nous centralisons les pièces, préparons les documents et suivons les échéances de la procédure.",
          "Vous conservez vos décisions ; nous préparons les actes et le dossier de formalités.",
        ],
      },
    ],
    faqs: [
      {
        q: "Qui peut demander l'ouverture d'un redressement judiciaire ?",
        a: "Le dirigeant lui-même (dans les 45 jours de la cessation de paiement), un créancier, ou le ministère public. Dans la pratique, les dossiers les mieux défendus sont ceux initiés par le dirigeant, avant citation d'un créancier.",
      },
      {
        q: "Le dirigeant garde-t-il la main pendant le redressement ?",
        a: "Oui, dans la grande majorité des dossiers de PME : l'administrateur judiciaire a une mission d'assistance ou de surveillance, pas de remplacement. Vous continuez à diriger, avec un cadre.",
      },
      {
        q: "Le redressement judiciaire est-il public ?",
        a: "Oui : le jugement d'ouverture est publié au BODACC. C'est la contrepartie de la protection offerte. Si la confidentialité est essentielle et que la cessation de paiement remonte à moins de 45 jours, la conciliation peut être préférable.",
      },
    ],
    seo: {
      title: "Redressement judiciaire — période d'observation et plan de continuation | ProSecours",
      description:
        "Redressement judiciaire : préparation de la requête, pièces justificatives, prise de date et dépôt auprès du greffe compétent. Premier échange gratuit.",
      keywords:
        "redressement judiciaire, période d'observation, plan de continuation, administrateur judiciaire, plan de redressement",
    },
  },
  {
    slug: "conciliation-entreprise",
    tag: "Procédure amiable",
    h1: "Conciliation : renégocier vos dettes en toute confidentialité.",
    lede:
      "Retards URSSAF, banque frileuse, fournisseurs impatients — mais une entreprise viable ? La conciliation permet de négocier un accord avec vos créanciers sous l'égide d'un conciliateur, sans publicité ni procédure collective. C'est l'outil des dirigeants qui agissent tôt.",
    sections: [
      {
        h: "Une procédure amiable, rapide et confidentielle",
        p: [
          "Contrairement au redressement, la conciliation n'est pas publiée au BODACC : vos clients, vos équipes et vos partenaires n'en savent rien. Elle dure environ 3 mois et se déroule sous l'autorité du président du tribunal.",
          "Condition essentielle : ne pas être en cessation de paiement depuis plus de 45 jours. C'est ce délai qui rend la préparation urgente du dossier essentielle quand la trésorerie se tend.",
        ],
      },
      {
        h: "L'accord homologué : un vrai bouclier juridique",
        p: [
          "L'accord trouvé avec les créanciers peut être homologué par le tribunal : il devient alors opposable et vous offre une sécurité juridique complète.",
          "Bonus stratégique : les apports nouveaux consentis pendant la conciliation (ligne de trésorerie, crédit) bénéficient du « privilège de conciliation » — ils sont remboursés en priorité en cas de procédure collective ultérieure. C'est ce qui rassure les banques.",
        ],
      },
      {
        h: "Comment nous préparons votre conciliation",
        p: [
          "Nous établissons d'abord la liste des pièces à réunir : éléments de trésorerie, créanciers concernés, échéanciers et justificatifs comptables.",
          "Puis nous préparons la demande d'ouverture, le dossier de pièces et le calendrier de dépôt. Vous choisissez la procédure ; nous organisons les formalités.",
        ],
      },
    ],
    faqs: [
      {
        q: "La conciliation est-elle visible publiquement ?",
        a: "Non. C'est sa grande force : aucune publication au BODACC, aucune inscription au RCS. Seuls le tribunal, le conciliateur et les créanciers invités à négocier sont informés.",
      },
      {
        q: "Combien de temps dure une conciliation ?",
        a: "La mission du conciliateur dure environ 3 mois. L'accord obtenu, lui, peut étaler les remboursements sur plusieurs années.",
      },
      {
        q: "Quelle différence avec le mandat ad hoc ?",
        a: "Le mandat ad hoc est encore plus souple (aucune condition de cessation de paiement, durée libre) mais l'accord ne peut pas être homologué et n'offre pas le privilège de conciliation. Vous choisissez la procédure ; nous préparons la demande et les pièces.",
      },
    ],
    seo: {
      title: "Conciliation entreprise — renégocier ses dettes en confidentialité | ProSecours",
      description:
        "Conciliation : procédure amiable et confidentielle pour renégocier les dettes de votre entreprise (URSSAF, banque, fournisseurs). Accord homologué, privilège de conciliation. Premier échange gratuit.",
      keywords:
        "conciliation entreprise, conciliateur, renégocier dettes entreprise, procédure amiable confidentielle, privilège de conciliation",
    },
  },
  {
    slug: "mandat-ad-hoc",
    tag: "Procédure amiable",
    h1: "Mandat ad hoc : la négociation souple, avant la crise.",
    lede:
      "Un créancier-clé à convaincre, une ligne bancaire à préserver, un actionnaire à apaiser ? Le mandat ad hoc ouvre une négociation encadrée par un mandataire nommé par le tribunal — sans aucune publicité et sans condition de cessation de paiement.",
    sections: [
      {
        h: "L'outil le plus souple du droit des difficultés",
        p: [
          "Le mandat ad hoc ne suppose ni cessation de paiement ni difficulté avérée : il suffit d'une tension à désamorcer. Aucune durée légale, aucune publication, aucune perte de pouvoir pour le dirigeant.",
          "Le mandataire ad hoc est nommé par le président du tribunal sur demande du dirigeant, avec une mission sur mesure : réunir les parties, structurer la négociation, proposer des solutions.",
        ],
      },
      {
        h: "Idéal pour débloquer une situation ciblée",
        p: [
          "Là où la conciliation vise un accord global, le mandat ad hoc excelle sur les blocages ponctuels : une banque qui hésite à renouveler une ligne, un fournisseur stratégique qui menace de couper les livraisons, des associés en désaccord.",
          "C'est aussi un excellent outil de repérage : il permet de tester la disposition des créanciers à négocier avant d'envisager une procédure plus formelle.",
        ],
      },
      {
        h: "Notre préparation du mandat",
        p: [
          "Un mandat ad hoc bien préparé se joue avant la saisine : à partir de vos instructions, nous préparons la demande, réunissons les éléments financiers et constituons le dossier de pièces.",
          "Pendant la mission, nous suivons les formalités et les échanges documentaires — le mandataire négocie, mais c'est vous qui décidez.",
        ],
      },
    ],
    faqs: [
      {
        q: "Le mandat ad hoc est-il public ?",
        a: "Non, totalement confidentiel : aucune publication, aucune inscription. Seuls le président du tribunal, le mandataire et les parties invitées à la négociation sont informés.",
      },
      {
        q: "Faut-il être en cessation de paiement pour ouvrir un mandat ad hoc ?",
        a: "Non — c'est toute la différence avec la conciliation. Le mandat ad hoc est accessible dès qu'une tension existe, même précoce. C'est l'outil de prévention par excellence.",
      },
      {
        q: "Mandat ad hoc ou conciliation : lequel choisir ?",
        a: "Le mandat ad hoc convient aux blocages ciblés et aux situations précoces ; la conciliation aux négociations globales nécessitant un accord homologué (avec privilège pour les financements nouveaux). Vous retenez la procédure ; nous préparons la demande et le dépôt.",
      },
    ],
    seo: {
      title: "Mandat ad hoc — négociation confidentielle avec les créanciers | ProSecours",
      description:
        "Mandat ad hoc : préparation de la demande, pièces justificatives et dépôt auprès du tribunal compétent, en toute confidentialité. Premier échange gratuit.",
      keywords:
        "mandat ad hoc, mandataire ad hoc, négociation créanciers, prévention difficultés entreprise, procédure amiable",
    },
  },
  {
    slug: "creation-de-societe",
    tag: "Formalités juridiques",
    h1: "Création de société : le bon statut, dès le premier jour.",
    lede:
      "SASU, SAS, SARL, EURL, SCI ou micro-entreprise : le choix du statut conditionne votre fiscalité, votre protection sociale et votre capacité à grandir. ProSecours rédige, publie et immatricule pour vous — tarif clair, annoncé avant de commencer.",
    sections: [
      {
        h: "Vous choisissez la forme juridique",
        p: [
          "SASU, SAS, SARL, EURL, SCI ou micro-entreprise : vous nous indiquez la structure que vous souhaitez créer, avec vos éléments de situation et votre calendrier.",
          "Nous rédigeons ensuite les statuts, publions l'annonce légale, réunissons les pièces et organisons l'immatriculation auprès du greffe compétent.",
        ],
      },
      {
        h: "Toutes les étapes prises en charge",
        p: [
          "Rédaction des statuts sur mesure, dépôt du capital, publication de l'annonce légale, constitution du dossier et immatriculation au greffe : nous gérons l'intégralité de la chaîne, avec un seul interlocuteur.",
          "Vous recevez votre Kbis en quelques jours et votre entreprise peut facturer immédiatement.",
        ],
      },
      {
        h: "Un tarif clair, sans surprise",
        p: [
          "Nos prestations de formalités démarrent à 215 € TTC pour une EURL, 239 € TTC pour une SASU ou une SARL, 275 € TTC pour une SAS et 299 € TTC pour une SCI. La création de micro-entreprise est offerte.",
          "Seuls les frais légaux et de greffe (identiques partout) restent à votre charge — ils vous sont détaillés avant tout engagement.",
        ],
      },
    ],
    faqs: [
      {
        q: "SASU ou EURL pour un freelance ?",
        a: "La SASU relève du régime général ; l'EURL relève du régime des indépendants. Vous choisissez la structure à créer ; nous préparons les statuts, l'annonce légale et l'immatriculation.",
      },
      {
        q: "Combien de temps pour créer ma société ?",
        a: "Comptez 5 à 10 jours ouvrés entre la signature des statuts et le Kbis, annonce légale et délais de greffe inclus. Une micro-entreprise peut être immatriculée en 24 à 48 heures.",
      },
      {
        q: "Les frais de greffe sont-ils inclus dans vos tarifs ?",
        a: "Non : les frais de greffe et d'annonce légale sont des montants réglementés, identiques quel que soit le prestataire, et restent à votre charge. Notre tarif couvre la rédaction des actes, la constitution du dossier et le suivi du dépôt.",
      },
    ],
    seo: {
      title: "Création de société — SASU, SAS, SARL, EURL, SCI | ProSecours",
      description:
        "Création de société clé en main : choix du statut (SASU, SAS, SARL, EURL, SCI, micro-entreprise), statuts, annonce légale, immatriculation au greffe. Tarifs TTC clairs. Premier échange gratuit.",
      keywords:
        "création de société, créer une SASU, créer une SARL, immatriculation greffe, statuts société, créer son entreprise",
    },
  },
];
